import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private apiUrl = 'https://gravitas.ai/payment/ccavenue/ccavRequestHandler.php';

  constructor(private http: HttpClient) {}

  initiatePayment(paymentData: any): Observable<any> {
    return this.http.post(this.apiUrl, paymentData);
  }
}
